import { intersection } from "lodash";
import React from "react";
import { Navigate, useLocation, redirect } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children, allowed }) {
  const { isAuthenticated, isInitialized, user, isProfileLoaded } = useAuth();
  const location = useLocation();
  // const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // Profiles store role as either a string ("ADMIN") or an array (["ADMIN"]);
  // normalize so the gate works with both shapes.
  const userRoles = Array.isArray(user?.role)
    ? user.role
    : user?.role
    ? [user.role]
    : [];
  const roleOk = allowed
    ? isAuthenticated && intersection(userRoles, allowed).length > 0
    : true;
  if (isInitialized && !isAuthenticated) {
    return (
      <Navigate
        to={"/auth/sign-in"}
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (isInitialized && isAuthenticated && !roleOk) {
    // Auth restores before the RTDB profile arrives on a refresh — don't
    // judge the role until it has actually loaded.
    if (!isProfileLoaded) {
      return null;
    }
    return <Navigate to={"/auth/401"} />;
  }

  return (
    <React.Fragment>{isAuthenticated && roleOk && children}</React.Fragment>
  );
}

export default AuthGuard;
